import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Version } from '../../models/version.model';
import { VersionService } from '../../services/version.service';

export interface VersionSearchDialogData {
  eventId: string;
  totalVersionCount: number;
}

@Component({
  selector: 'app-version-search-dialog',
  templateUrl: './version-search-dialog.component.html',
  styleUrls: ['./version-search-dialog.component.scss'],
})
export class VersionSearchDialogComponent implements OnInit, OnDestroy {
  constructor(
    private versionService: VersionService<Version>,
    private dialogRef: MatDialogRef<VersionSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VersionSearchDialogData,
  ) {}

  ngOnInit(): void {
    this.versionService.eventId = this.data.eventId;
  }

  ngOnDestroy(): void {
    this.versionService.setAttributeFilterPairs([]);
  }

  close(): void {
    this.dialogRef.close();
  }
}
